import { getIsCountriesApiPending, getQuoteForm, getSelectedCover } from '../../../selectors/travelUg/quote';
import {
    apiTransitionCountries,
    setCountriesList,
    setDepartureCountriesValue,
    setDestinationCountriesValue,
} from '../../../actions/travelUg/quote';
import { getAccessToken } from '../../../selectors/travelUg/payments';
import axios from 'axios';
import { COVER_PLANS } from '../../../actions/travelUg/types';

export const getCountriesService = (store, next, action) => {
    (async () => {
        if (!getIsCountriesApiPending(store.getState())) {
            store.dispatch(apiTransitionCountries.pending());
            try {
                store.dispatch(setDestinationCountriesValue(null));
                store.dispatch(setDepartureCountriesValue(null));
                const resp = await getCountries(store.getState());
                let countriesArr = Array.isArray(resp.data) ? resp.data : [];

                countriesArr.sort((a, b) => (a?.name ?? '').localeCompare(b?.name ?? ''));

                store.dispatch(setCountriesList(countriesArr));

                const selectedCover = getSelectedCover(store.getState());
                const uganda = { id: 36, name: 'Uganda', area: 'Africa&Asia' };

                let destinationCountries = countriesArr.filter((c) => c.name !== 'Uganda');
                let departureCountries = [uganda];

                if (selectedCover?.value === COVER_PLANS.INBOUND_COVER.value) {
                    destinationCountries = [uganda];
                    departureCountries = countriesArr.filter((c) => c.name !== 'Uganda');
                }

                store.dispatch(setDestinationCountriesValue(destinationCountries));

                store.dispatch(setDepartureCountriesValue(departureCountries));

                store.dispatch(apiTransitionCountries.success());
            } catch (e) {
                console.error(e);
                store.dispatch(apiTransitionCountries.failure());
            }
        }
    })();
    return next(action);
};

const getCountries = async (state) => {
    const loginData = getAccessToken(state);

    const quotation = getQuoteForm(state);

    let countriesType = '';

    if (quotation.selectedCover?.value.includes(COVER_PLANS.SCHENGEN_COVER.title)) {
        countriesType = 'Schengen';
    }

    if (quotation.selectedCover?.value.includes(COVER_PLANS.WORLDWIDE_COVER.title)) {
        countriesType = 'Worldwide';
    }

    if (quotation.selectedCover?.value === COVER_PLANS.AFRICA_ASIA_COVER.value) {
        countriesType = 'Africa&Asia';
    }

    try {
        const url = '/om-api/travel-ug/countries';
        return await axios.get(url, {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
                countriesType: countriesType,
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};
